/* eslint-disable ember/classic-decorator-no-classic-methods, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';

export default class SetsController extends Controller {
  @service
  session;

  @service
  router;

  @service
  store;

  @service
  paperToaster;

  @tracked
  setName = '';

  @action
  setSetName(value) {
    this.setName = value;
  }

  @tracked
  setDescription = '';

  @action
  setSetDescription(value) {
    this.setDescription = value;
  }

  @tracked
  setId = '';

  @tracked
  setDialogOpen = false;

  @tracked
  saveInProgress = false;

  @tracked
  deleteSetDialogOpen = false;

  @tracked
  deleteInProgress = false;

  @tracked
  errorMessage = '';

  // toggleDialog opens the set dialog.
  toggleDialog() {
    this.errorMessage = '';
    this.toggleProperty('setDialogOpen');
    if (!this.setDialogOpen) {
      this.resetForm();
    }
  }

  @action
  toggleSetDialog() {
    this.toggleDialog();
  }

  @action
  editSet(id) {
    this.store.findRecord('school-options/set', id).then((set) => {
      this.setName = set.get('name');
      this.setDescription = set.get('description');
    });
    this.setId = id;
    this.toggleDialog();
  }

  @action
  saveSet() {
    this.saveInProgress = true;
    this.errorMessage = '';
    let promise;
    let action = 'create';

    if (isEmpty(this.setId)) {
      promise = new Promise((resolve) => {
        let record = this.store.createRecord('school-options/set', {
          name: this.setName,
          description: this.setDescription,
        });

        resolve(record);
      });
    } else {
      action = 'update';
      promise = new Promise((resolve) => {
        const id = this.setId;
        this.store.findRecord('school-options/set', id).then((set) => {
          set.set('name', this.setName);
          set.set('description', this.setDescription);

          resolve(set);
        });
      });
    }

    promise.then((record) => {
      return record
        .save()
        .then(() => {
          this.setDialogOpen = false;
          this.resetForm();
        })
        .catch((err) => {
          this.handleError(err, action);
          record.rollbackAttributes();
        })
        .then(() => {
          this.saveInProgress = false;
          if (action === 'create') {
            this.router.refresh('school-options.sets');
          }
        });
    });
  }

  @action
  deleteSet(id) {
    this.errorMessage = '';
    this.store.findRecord('school-options/set', id).then((set) => {
      this.setName = set.get('name');
    });
    this.setId = id;
    this.deleteSetDialogOpen = true;
  }

  @action
  confirmDelete(confirmed) {
    return new Promise((resolve, reject) => {
      if (confirmed) {
        // Deletion confirmed; actually delete the record.
        this.deleteInProgress = true;

        // Grab record from local store - no GET request, as that causes weirdness.
        // We only need the ID to issue the DELETE anyway, which can't change, so no need to use findRecord.
        let set = this.store.peekRecord('school-options/set', this.setId);

        // Delete record (locally + pushed to server).
        return set
          .destroyRecord()
          .then(resolve)
          .catch((err) => {
            // Remove 'deleted' flag so that entity can be interacted with again.
            set.rollbackAttributes();
            reject(err);
          });
      } else {
        resolve();
      }
    })
      .then(() => {
        // Tidy up / close dialog.
        this.deleteSetDialogOpen = false;
        this.setId = '';
        this.setName = '';
      })
      .catch((err) => {
        this.handleError(err, 'delete');
      })
      .then(() => {
        this.deleteInProgress = false;
      });
  }

  handleError(err) {
    if (!isEmpty(err.errors.msg)) {
      this.errorMessage = err.errors.msg;
    } else {
      this.errorMessage = err.message;
    }
  }

  setErrorMessage(code, action) {
    var message = 'An unknown error occurred.  Please try again.';
    const codes = {
      400: 'Sorry, your request was invalid.  Please check all details below, and try again.',
      403: {
        create:
          'Sorry, you are not authorised to create a new user.  Please check that you are logged in as the correct user, and try again.',
        update:
          'Sorry, you are not authorised to edit this user.  Please check that you are logged in as the correct user, and try again.',
        delete:
          'Sorry, you are not authorised to delete this user.  Please check that you are logged in as the correct user, and try again.',
      },
      409: 'A user already exists with that username.  Please double-check the details, or find and update the existing user.',
    };

    if (!isEmpty(codes[code][action])) {
      message = codes[code][action];
    } else if (!isEmpty(codes[code])) {
      message = codes[code];
    }

    this.errorMessage = message;
  }

  resetForm() {
    this.setId = '';
    this.setName = '';
    this.setDescription = '';
  }
}
